export const DEFAULT_MINIMUM_DELAY_MS = 250;
export const DEFAULT_SLOW_STATE_DELAY_MS = 8000;
